export const employment_status = (t) => [
  {
    label: t("Employed (full time)"),
    value: "Employed (full time)" 
  },
  {
    label: t("Self Employed"),
    value: "Self Employed" 
  },
  {
    label: t("Employed (part time)"),
    value: "Employed (part time)" 
  },
  {
    label: t("Unemployed"),
    value: "Unemployed" 
  },
  {
    label: t("Student"),
    value: "Student" 
  },
  {
    label: t("Retired"),
    value: "Retired" 
  }
];

export const employment_industries  = (t) => [
  {
    label: t("Aviation"),
    value: "Aviation"
  },
  {
    label: t("Agricultural"),
    value: "Agricultural"
  },
  {
    label: t("Financial industry"),
    value: "Financial industry"
  },
  {
    label: t("Marketing"),
    value: "Marketing"
  },
  {
    label: t("Retail industry"),
    value: "Retail industry"
  },
  {
    label: t("HR"),
    value: "HR"
  },
  {
    label: t("Management"),
    value: "Management"
  },
  {
    label: t("Health care"),
    value: "Health care"
  },
  {
    label: t("Administration"),
    value: "Administration"
  },
  {
    label: t("Academic"),
    value: "Academic"
  },
  {
    label: t("Engineering"),
    value: "Engineering"
  },
  {
    label: t("Civil Engineering"),
    value: "Civil Engineering"
  },
  {
    label: t("Architecture"),
    value: "Architecture"
  },
  {
    label: t("Media"),
    value: "Media"
  },
  {
    label: t("Chemical engineering"),
    value: "Chemical engineering"
  },
  {
    label: t("Power engineering"),
    value: "Power engineering"
  },
  {
    label: t("Other"),
    value: "Other"
  }
];

export const source_of_funds = (t) => [
  {
    value: "Employment",
    label: t("Employment") 
  },
  {
    value: "Inheritance",
    label: t("Inheritance") 
  },
  {
    value: "Third party",
    label: t("Third party") 
  },
  {
    value: "Grant/Loan",
    label: t("Grant/Loan") 
  }
];